<template>
  <v-row ref="editForm" no-gutters class="edit-form edit-info-form">
    <v-col cols="12" class="pt-3">
      <v-row no-gutters class="custom-label-radiogroup">
        <v-col cols="12" sm="4">

          <div class="pt-1">
            In Kopie: Schriftwechsel
          </div>

        </v-col>

        <v-col cols="12" sm="8">

          <v-radio-group v-model="kopie"
                         :disabled="disableKopieVSSN && disableKopieSS"
                         hide-details
                         row
                         @change="setKopieMail">
            <v-radio label="per E-Mail"
                     value="2"
                     color="primary" />
            <!--v-radio label="per Post"
                     value="1"
                     color="primary"/-->
            <v-radio label="kein Versand"
                     value="0"
                     color="primary"/>
          </v-radio-group>

          <template v-if="kopie==='2'">
            <v-text-field v-model.trim="userForm.kopieadresse"
                          v-validate="'required|email'"
                          :error-messages="errors.collect('kopieadresse')"
                          data-vv-as="E-Mail"
                          class="required"
                          name="kopieadresse"
                          label="E-Mail"/>
          </template>

        </v-col>
      </v-row>
    </v-col>

    <v-col v-if="kopie!=='0'" cols="12">
      <div :class="kopie==='1' ? 'pt-3' : ''"
                class="mb-1">

        <div class="custom-label-inputgroup">
          <v-checkbox v-model="kopiewas"
                      v-validate="'required'"
                      :error-messages="errors.collect('kopiewas')"
                      :disabled="disableKopieVSSN"
                      color="primary"
                      value="1"
                      label=""
                      name="kopiewas"
                      hide-details />
          <span class="mylabel">Versicherungsscheine/Nachträge</span>
        </div>

        <div class="custom-label-inputgroup">
          <v-checkbox v-model="kopiewas"
                      v-validate="'required'"
                      :error-messages="errors.collect('kopiewas')"
                      :disabled="disableKopieSS"
                      color="primary"
                      value="4"
                      label=""
                      name="kopiewas"
                      hide-details />
          <span class="mylabel">Rechnungen / Mahnungen</span>
        </div>

        <div class="custom-label-inputgroup">
          <v-checkbox v-model="kopiewas"
                      v-validate="'required'"
                      :error-messages="errors.collect('kopiewas')"
                      :disabled="disableKopieSS"
                      color="primary"
                      value="8"
                      label=""
                      name="kopiewas"
                      hide-details />
          <span class="mylabel">Hauptfälligkeitsschreiben
            <site-tooltip>Inhalt Hauptfälligkeitsschreiben:
              <ul>
                <li>BAK-Vorabinfo VN</li>
                <li>Jahres-Prenotifikation VN</li>
                <li>Stammdatenänderungen VN</li>
                <li>Risikoänderungen (z.B.: EP > MP)</li>
              </ul>
            </site-tooltip>
          </span>
        </div>

        <div class="custom-label-inputgroup">
          <v-checkbox v-model="kopiewas"
                      v-validate="'required'"
                      :error-messages="errors.collect('kopiewas')"
                      :disabled="disableKopieSS"
                      color="primary"
                      value="16"
                      label=""
                      name="kopiewas"
                      hide-details />
          <span class="mylabel">Meldebögen
            <site-tooltip>Meldebögen für
              <ul>
                <li>KOMPEX</li>
                <li>KOMedEX</li>
                <li>AGROMEX</li>
                <li>Verkehrs-Rechtsschutz für Selbstständige</li>
                <li>Immobilien-Rechtsschutz</li>
                <li>Vermieter-Rechtsschutz</li>
              </ul>
            </site-tooltip>
          </span>
        </div>

        <div class="custom-label-inputgroup">
          <v-checkbox v-model="kopiewas"
                      v-validate="'required'"
                      :error-messages="errors.collect('kopiewas')"
                      :disabled="disableKopieSS"
                      color="primary"
                      value="2"
                      label=""
                      name="kopiewas"
                      hide-details />
          <span class="mylabel">Sonstiger Schriftwechsel</span>
        </div>

        <div v-if="errors.has('kopiewas')"
             class="v-messages error--text mb-4 mt-n2" >Bitte wählen Sie mindestens eine Schriftwechselart aus.
        </div>

      </div>
    </v-col>

    <v-col cols="12">
      <v-row no-gutters class="custom-label-radiogroup">

        <v-col cols="12" sm="4">

          <div class="pt-1">
            Courtage-Abrechnungen
          </div>

        </v-col>

        <v-col cols="12" sm="8">

          <v-radio-group v-model="userForm.provmail"
                         hide-details
                         row
                         @change="setProvMail">
            <v-radio label="per E-Mail"
                     value="1"
                     color="primary" />
            <v-radio label="per Post"
                     value="0"
                     color="primary"/>
          </v-radio-group>

          <template v-if="userForm.provmail==='1'">
            <v-text-field v-model.trim="userForm.provmailadresse"
                          v-validate="'required|email'"
                          :error-messages="errors.collect('provmailadresse')"
                          data-vv-as="E-Mail"
                          class="required"
                          name="provmailadresse"
                          label="E-Mail"/>
          </template>

        </v-col>
      </v-row>
    </v-col>

  </v-row>
</template>
<script>
import ValidationMixin from "@/components/helper/ValidationMixin";
import SiteTooltip from "@/components/SiteTooltip";
import {SCHRIFTWECHSELART_VALUES, VSSN_VALUE, SS_VALUE} from "@/components/userProfile/valueLists";
export default {
  name: "EditInfo",
  components: { SiteTooltip },
  mixins: [ ValidationMixin ],
  props: {
    userForm: {
      type: Object,
      required: true
    },
    defaultMail: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      originalwas: [],
      kopiewas: [],
      kopie: ""
    };
  },
  computed : {
    disableKopieVSSN() {
      return this.$helpers.isBitSet(this.userForm.originalwas, VSSN_VALUE);
    },
    disableKopieSS() {
      return this.$helpers.isBitSet(this.userForm.originalwas, SS_VALUE);
    }
  },
  watch: {
    // transform radiobutton selection from array to sum of powers of 2
    originalwas () {
      this.userForm.originalwas = this.originalwas.length !== 0 ?
        this.originalwas.reduce((sum, val) => sum + Number(val), 0).toString() :
        "0";
    },
    'userForm.originalwas' () {
      this.checkKopieVersand();
    },
    // transform radiobutton selection from array to sum of powers of 2
    kopiewas () {
      this.userForm.kopiewas = this.kopiewas.length !== 0 ?
        this.kopiewas.reduce((sum, val) => sum + Number(val), 0).toString() :
        "0";
    },
    /* transform radio button selection for sending copies into attributes userForm.kopiepost and kopiewas
     * 0:  send nothing => kopiewas is empty
     * 1:  per post => userForm.kopiepost is "1"
     * 2:  per email => userForm.kopiepost is "0"
     * */
    kopie (value) {
      if (value === "0") this.kopiewas = [];
      if (value === "1") this.userForm.kopiepost = "1";
      if (value === "2") this.userForm.kopiepost = "0";
    },
    defaultMail () {
      this.setKopieMail(this.kopie);
      this.setProvMail(this.userForm.provmail);
    }
  },
  mounted () {
    /*for original documents we only differ between Versicherungsschein/Nachträge (1) and Sonstiger Schriftwechsel (2)
    * the latter includes the other types like Rechnungen/Mahnungen etc.
    * */
    [VSSN_VALUE, SS_VALUE].forEach(pos => {
      if (this.$helpers.isBitSet(this.userForm.originalwas, pos)) this.originalwas.push(pos);
    });
    SCHRIFTWECHSELART_VALUES.map(a => a.value).forEach(pos => {
      if (this.$helpers.isBitSet(this.userForm.kopiewas, pos)) this.kopiewas.push(pos);
    });
    this.kopie = this.kopiewas.length === 0 ? "0" : this.userForm.kopiepost === "1" ? "1" : "2";
    this.checkKopieVersand();
    this.setKopieMail(this.kopie);
    this.setProvMail(this.userForm.provmail);
  },
  methods: {
    checkKopieVersand () {
      //if a document is sent in the original, no copies will be sent
      if (this.$helpers.isBitSet(this.userForm.originalwas, VSSN_VALUE) && this.$helpers.isBitSet(this.userForm.originalwas, SS_VALUE)) {
        this.kopiewas = [];
        this.kopie = "0";
      } else if (this.$helpers.isBitSet(this.userForm.originalwas, VSSN_VALUE)) {
        this.kopiewas = this.kopiewas.filter(v => v !== VSSN_VALUE);
      }
      else if (this.$helpers.isBitSet(this.userForm.originalwas, SS_VALUE)) {
        this.kopiewas = this.kopiewas.filter(v => v === VSSN_VALUE);
      }
    },
    setKopieMail (rbValue) {
      if (rbValue === "2" && this.defaultMail && !this.userForm.kopieadresse)
        this.userForm.kopieadresse = this.defaultMail;
    },
    setProvMail (rbValue) {
      if (rbValue === "1" && this.defaultMail && !this.userForm.provmailadresse)
        this.userForm.provmailadresse = this.defaultMail;
    }
  }
};
</script>
<style>
.edit-info-form .v-input.v-input--radio-group {
  max-width: unset;
}
.edit-info-form .custom-label-inputgroup {
  display: flex;
  align-items: center;
  padding-right: 48px;
  margin-bottom: 16px;
}
.edit-info-form .custom-label-inputgroup .v-input {
  margin: 0;
  padding: 0;
}
.edit-info-form .custom-label-inputgroup .mylabel {
  width: 100%;
}
.edit-info-form .custom-label-inputgroup .v-input--is-disabled+.mylabel {
  color: rgba(0,0,0,.38) !important;
}
.edit-info-form .custom-label-inputgroup .mylabel .dmb--tooltip .v-icon {
  position: absolute;
  bottom: -1px;
  left: 4px;
}
.edit-info-form .custom-label-radiogroup {
  display: flex;
  align-items: flex-start;
}
</style>
